import React from "react";
import { Button, ArrowRightIcon } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const TextButtonWithEndIcon = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Text button with end icon"}
        value={
          '<Button variant={"text"} endIcon={<ArrowRightIcon />}>Next</Button>'
        }
      >
        <Button variant={"text"} endIcon={<ArrowRightIcon />}>
          Next
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default TextButtonWithEndIcon;
